import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'
import { CookieStorage } from 'cookie-storage'
import dayjs from 'dayjs'
import { Capacitor } from '@capacitor/core'
import { getAppDomain, getIS4BaseUrl, getAppBaseUrl } from '@/helpers/env'

//TODO: I implemented CookieStorageCapacitor but it not working
// FOR NOW ONLY localStorage is working in native app
const cookieStorage = Capacitor.isNativePlatform()
  ? window.localStorage
  : new CookieStorage({
      expires: dayjs().add(14, 'day').toDate(),
      domain: getAppDomain(),
      path: '/',
    })

export default function useUserManagerSettings(): UserManagerSettings {
  const isIos = Capacitor.getPlatform() === 'ios'
  const callbackBase = isIos ? 'easybudgetpl://' : `${getAppBaseUrl()}/`

  return {
    userStore: new WebStorageStateStore({ store: cookieStorage }),
    stateStore: new WebStorageStateStore({ store: cookieStorage }),
    authority: getIS4BaseUrl(),
    client_id: 'easybudget.client',
    redirect_uri: `${callbackBase}callback`,
    automaticSilentRenew: !isIos,
    silent_redirect_uri: `${getAppBaseUrl()}/silentRenew`,
    response_type: 'code',
    scope: 'openid profile easybudget.api',
    post_logout_redirect_uri: isIos ? 'easybudgetpl://' : `${getAppBaseUrl()}`,
    filterProtocolClaims: true,
  }
}
